import React, { Component } from "react";
import { withApollo } from "@apollo/react-hoc";
import { FlowChart } from "@mrblenny/react-flow-chart";
import * as actions from "@mrblenny/react-flow-chart/src/container/actions";
import { customNode } from "../../molecules/custom-node/customNode";
import { jdcMrFlow, jdcWorkFlow } from "../../../utils/jdcToGr";
import NodeInnerCustom from "../../molecules/node-inner-custom";
import PortCustom from "../../molecules/port-custom/PortCustom";
import CustomLinkWrapper from "../../molecules/custom-link-wrapper";
import PropertyBar from "../property-bar";
import { WorkflowCustomCallbacks } from "../../atoms/workflow-custom-callbacks";
import {
  customOnCanvasDrop,
  customOnDeleteKey,
  customOnDragNode,
  customOnLinkComplete,
} from "../../../utils/customActions";
import { ContextAnalyzer } from "../../../utils/contextAnalyzer";
import { dbType } from "../../../utils/mrTypes";
import ConfirmationModal from "../confirmation-modal";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
class WorkFlow extends Component {
  constructor(props) {
    super(props);
    const { jdc } = props;
    this.state = {
      offset: { x: 0, y: 0 },
      nodes: {},
      links: {},
      selected: {},
      hovered: {},
      openModal: false,
      openConfirmation: false,
      mode: jdc.mode,
    };
    //
    this.propertyArgs = {}; // argumentos que se entregaran  al componente propertyBar
    this.stateActions = {};
    //
    //
    this.updateActions();
    this.onPropertyChange = this.onPropertyChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.externalEditPropertyLink = this.externalEditPropertyLink.bind(this);
    this.externalEditPropertyNode = this.externalEditPropertyNode.bind(this);
    //intento de control de estados
    this.prevState = {
      offset: { x: 0, y: 0 },
      nodes: {},
      links: {},
      selected: {},
      hovered: {},
      openModal: false,
      mode: jdc.mode,
    };
    //control de cuando se informa al editor
    this.shouldInform = true;
  }
  componentDidMount() {
    const { jdc } = this.props;
    if (this.state.mode === "workflow") {
      this.setState({ ...jdcWorkFlow(jdc) });
      this.slug = jdc.slug;
      this.id = jdc.id;
    } else if (this.state.mode === "MR") {
      this.setState({ ...jdcMrFlow(jdc) });
      this.slug = "Models";
      this.id = this.state.mode;
    }
    this.evenKey();
  }

  componentDidUpdate() {
    if (
      (JSON.stringify(this.state.offset) !==
        JSON.stringify(this.prevState.offset) ||
        JSON.stringify(this.state.nodes) !==
          JSON.stringify(this.prevState.nodes) ||
        JSON.stringify(this.state.links) !==
          JSON.stringify(this.prevState.links)) &&
      this.shouldInform
    ) {
      // console.log("informa");
      this.props.onWorkflowChange(this.id, this.slug, this.state);
      this.prevState = JSON.parse(JSON.stringify(this.state));
      this.shouldInform = false;
    }
  }

  externalEditPropertyLink(args) {
    //for now is focused on creating connections in the "Data Models"
    if (this.editPropertyLink(args)) this.toggleModal();
  }
  editPropertyLink(args) {
    const validation = this.state.mode === "MR" && args != null;
    if (validation) {
      this.propertyArgs = { data: args, type: "link", dependencies: {} };
    }
    return validation;
  }

  externalEditPropertyNode(args) {
    if (this.editPropertyNode(args)) {
      //open  propertyBar
      this.toggleModal();
    }
  }
  editPropertyNode(args) {
    // console.log("edit node");
    const validate = true;
    if (validate) {
      const nodeNames = Object.entries(this.state.nodes).map(
        ([key, o]) => o.properties.name
      );
      const models = this.props.getModels();
      const context = new ContextAnalyzer(
        this.state.nodes,
        this.state.links,
        this.state.nodes[args.id],
        models
      );
      this.propertyArgs = {
        data: args,
        type: "node",
        dependencies: {
          nodeNames: nodeNames,
          context: context.findRelatedContext(),
          getModels: this.props.getModels,
        },
      };
    }
    return validate;
  }
  onPropertyChange(callBack) {
    this.shouldInform = true;
    this.setState(callBack, () => {
      this.toggleModal();
    });
  }
  toggleModal() {
    if (this.state.openModal && this.state.mode === "MR") {
      if (
        this.propertyArgs.type === "node" &&
        !this.state.nodes[this.propertyArgs.data.id].properties.name
      ) {
        this.setState((state) => {
          delete state.nodes[this.propertyArgs.data.id];
          return state;
        });
      }
    }
    if(this.propertyArgs && this.propertyArgs.type !== "link")
      this.setState({ openModal: !this.state.openModal });
  }
  updateActions() {
    this.stateActions = Object.fromEntries(
      Object.entries(actions).map(([key, o]) => [
        key,
        (...args) => {
          switch (key) {
            case "onLinkComplete":
              this.shouldInform = true;
              this.setState(
                customOnLinkComplete(...args, (link) => {
                  if (this.editPropertyLink(link)){
                    //se ha desabilitado la configuracion de enlaces entre modelos
                    //ya que ocasiona comportamientos erraticos
                     //return { openModal: true };
                     return { openModal: false };
                    }
                })
              );
              break;
            case "onCanvasDrop":
              this.setState(
                customOnCanvasDrop(...args, (node) => {
                  if (node.type === dbType && this.editPropertyNode(node))
                    return { openModal: true };
                })
              );
              break;
            case "onDeleteKey":
              this.shouldInform = true;
              if (
                this.state.selected.type === "node" &&
                this.state.nodes[this.state.selected.id].type === dbType
              ) {
                this.setState({ openConfirmation: true });
              } else {
                this.setState(customOnDeleteKey(...args));
              }
              break;
            case "onDragNode":
              this.setState(customOnDragNode(...args));
              break;
            case "onDragNodeStop":
              this.shouldInform = true;
              this.setState(o(...args));
              break;
            case "onDragCanvasStop":
              this.shouldInform = true;
              this.setState(o(...args));
              break;
            default:
              this.setState(o(...args));
              break;
          }
        },
      ])
    );
  }
  evenKey() {
    document.addEventListener(
      "keydown",
      async (e) => {
        if (
          (window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) &&
          e.key === "s" &&
          this.id === this.props.activeTab
        ) {
          e.preventDefault();
          this.props.onSaveWorkflow();
        }
      },
      false
    );
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", () => true, false);
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  render() {
    return (
      <>
        <WorkflowCustomCallbacks.Provider
          value={{
            editPropertyLink: this.externalEditPropertyLink,
            editPropertyNode: this.externalEditPropertyNode,
            getModels: this.props.getModels,
          }}
        >
          <FlowChart
            chart={this.state}
            callbacks={this.stateActions}
            config={{
              smartRouting: this.state.mode === "MR",
              validateLink: ({
                /// validacion de los link
                linkId,
                fromNodeId,
                fromPortId,
                toNodeId,
                toPortId,
                chart,
              }) => {
                const fromNode = chart.nodes[fromNodeId];
                const toNode = chart.nodes[toNodeId];
                const linkForWorkflows = Object.entries(chart.links)
                  .map(([key, o]) => o)
                  .filter(
                    (o) =>
                      o.from.nodeId === fromNodeId &&
                      o.from.portId === fromPortId
                  );
                const linkForModels = Object.entries(chart.links)
                  .map(([key, o]) => o)
                  .filter(
                    (o) =>
                      o.from.nodeId === fromNodeId &&
                      o.from.portId === fromPortId &&
                      o.to.nodeId === toNodeId &&
                      o.to.portId === toPortId
                  );
                return (
                  fromNode.ports[fromPortId].properties.mode === "output" &&
                  toNode.ports[toPortId].properties.mode === "input" &&
                  ((chart.mode === "MR" && linkForModels.length === 0) ||
                    linkForWorkflows.length <= 1)
                );
              },
            }}
            Components={{
              NodeInner: NodeInnerCustom,
              Node: customNode,
              Link: CustomLinkWrapper,
              Port: PortCustom,
            }}
          />
          <PropertyBar
            toggle={this.toggleModal}
            open={this.state.openModal}
            args={this.propertyArgs}
            onPropertyChange={this.onPropertyChange}
          />
          <ConfirmationModal
            isOpen={this.state.openConfirmation}
            title={t("confirmeEliminacionModelo")}
            closeButtonText={t("cancelar")}
            closeAction={() => this.setState({ openConfirmation: false })}
            primaryButtonText={t("confirmar")}
            primaryAction={() => {
              this.setState(customOnDeleteKey());
              this.setState({ openConfirmation: false });
            }}
          >
            <p>
              <T i18nKey="mensajeEliminacionModelo" />
            </p>
          </ConfirmationModal>
        </WorkflowCustomCallbacks.Provider>
      </>
    );
  }
}
export default withApollo(WorkFlow);
